import { useCallback, useEffect, useState } from "react";
import api from "./api";
import { useAuth } from "./auth";

export function useApprovalQueue() {
  const { user } = useAuth();
  const canView = user?.role === "customer" && user?.invoice_service !== false;
  const isApprover = canView && Boolean(user?.is_approver);
  const [queue, setQueue] = useState([]);
  const [loading, setLoading] = useState(canView);

  const refresh = useCallback(async () => {
    if (!canView) return setQueue([]);
    try {
      const { data } = await api.get("/invoices/pending-approval");
      setQueue(data);
    } catch { setQueue([]); }
    finally { setLoading(false); }
  }, [canView]);

  useEffect(() => { refresh(); }, [refresh]);

  return { queue, count: queue.length, loading, refresh, isApprover, canView };
}
